import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "react-query";
import { toast } from "react-toastify";
import { getFriendlyErrorMessage, logSystemError } from "../services/httpClient";

const showGlobalErrorToast = (error) => {
  if (error?.skipGlobalNotification) {
    return;
  }

  const language = localStorage.getItem("language") || "pt";
  const message = getFriendlyErrorMessage(error, language);
  toast.error(message);

  if (error?.type === "system") {
    logSystemError(error, "react-query");
  }
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      showGlobalErrorToast(error);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      showGlobalErrorToast(error);
    },
  }),
});

export const ReactQueryProvider = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};